import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Allocation, ProductInstance } from "../../types";
import { foundIn } from "../../utils";

export const AllocationActions = {
  ASSIGN: "assign",
  CREATE: "create",
  ADD_ISSUE: "add_issue",
  RESOLVE_ISSUE: "resolve_issue",
  UNASSIGN: "unassign",
  FINISH: "finish",
  CANCEL: "cancel",
};

export const AllocationStatusColor = {
  UNASSIGNED: "#827717", //same with User Active
  GOT_ISSUE: "#FFA000",
  ASSIGNED: "#FF6F00",
  DONE: "#C7C7C7", //same with Issue Open
  CANCELLED: "#E91E63",
};

export const canAllocation = (
  allocation: Allocation,
  action: string,
): boolean => {
  switch (action) {
    // case AllocationActions.DELETE:
    //   // can only delete the Allocation, if the Booking status is
    //   // accepted or draft.
    //   return foundIn(get(allocation, "booking.status", ""), []);

    case AllocationActions.ASSIGN:
      return foundIn(allocation.status, [AllocationStatus.ASSIGNED]);

    case AllocationActions.UNASSIGN:
      return foundIn(allocation.status, [AllocationStatus.UNASSIGNED]);

    case AllocationActions.ADD_ISSUE:
      return foundIn(allocation.status, [AllocationStatus.GOT_ISSUE]);

    // case  AllocationActions.UNASSIGN:
    //   return foundIn(allocation.status, [AllocationStatus.UNASSIGNED]);

    case AllocationActions.FINISH:
      return foundIn(allocation.status, [AllocationStatus.DONE]);

    case AllocationActions.CANCEL:
      return foundIn(allocation.status, [AllocationStatus.CANCELLED]);

    default:
      return false;
  }
};

export const AllocationStatus = {
  UNASSIGNED: "unassigned",
  GOT_ISSUE: "got_issue",
  ASSIGNED: "assigned",
  DONE: "done",
  CANCELLED: "cancelled",
};

/**
 * Allocation statuses where the product set is considered assigned.
 * Used for: "Assigned" filter tab in the allocation list.
 */
export const ALLOCATED_STATUSES = [
  AllocationStatus.ASSIGNED,
  AllocationStatus.DONE,
];

/**
 * Allocation statuses where the product set is NOT yet assigned.
 * Used for: "Not Assigned" filter tab & Product Set column rendering
 * (shows "Not yet assigned" text instead of chip).
 */
export const UNALLOCATED_STATUSES = [
  AllocationStatus.UNASSIGNED,
  AllocationStatus.GOT_ISSUE,
  AllocationStatus.CANCELLED,
];

/**
 * Allocation statuses shown as "Not yet assigned" text in the Allocation Status column.
 * Difference from UNALLOCATED_STATUSES: "cancelled" is excluded because cancelled
 * records still display their AllocationChip in the status column.
 */
export const ALLOCATION_STATUS_NOT_ASSIGNED = [
  AllocationStatus.UNASSIGNED,
  AllocationStatus.GOT_ISSUE,
];

export const AllocationStatusList = Object.entries(AllocationStatus).map(
  ([, value]) => ({ id: value, name: value }),
);

/**
 * Product type enum values.
 * Used for: filtering allocations by product type and displaying the product type column.
 */
export const ProductType = {
  INSTRUMENT: "instrument",
  IMPLANT: "implant",
  OTHER: "other",
};

/**
 * Product type choices formatted for React-Admin SelectInput.
 * Usage: `<SelectInput choices={ProductTypeList} />`
 */
export const ProductTypeList = Object.entries(ProductType).map(([, value]) => ({
  id: value,
  name: value.charAt(0).toUpperCase() + value.slice(1),
}));

export const getName = (instance: ProductInstance) => {
  return `${instance.name} (ID ${instance.id}, Product ID: ${instance.product_id})`;
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      width: "100%",
    },
  }),
);
